"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const StyledTypographyTitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    textTransform: "uppercase",
    marginLeft: theme.spacing(3),
}));
const StyledTypographySubtitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));
const CardTitle = ({ title, lastUpdatedDate = "Not available", }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(StyledTypographyTitle, { variant: "h6", "data-report": "hide-on-print", "data-testid": "card-title" }, title),
    react_1.default.createElement(StyledTypographySubtitle, { variant: "caption", "data-testid": "card-subtitle" },
        "Last updated: ",
        lastUpdatedDate)));
exports.default = CardTitle;
